







import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class MoreLessSelect extends Vue {
  @Prop({ default: 0}) value?: number;
  @Prop({ default: false }) addDisabled?: boolean;
  @Prop({ default: false }) subtractDisabled?: boolean;

  add() {
    this.$emit("add");
    if (this.value != undefined){
      this.$emit("input", this.value + 1);
    }
  }

  subtract() {
    this.$emit("subtract");
    if (this.value != undefined){
      this.$emit("input", this.value - 1);
    }
  }
}
